import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment'
import 'moment/locale/sv'

@Pipe({
	name: 'moment',
	standalone: false
})
export class MomentPipe implements PipeTransform {
	transform(date: Date | string, format: string): any {
		return moment(date).format(format)
	}
}
